import * as React from 'react';
import s from './Mobile.module.less';

type Props = {
  title: string;
  children: React.ReactNode;
};

const FilterGroup = ({ title, children }: Props) => (
  <li className={s.multiFilter} data-testid={`filterGroup-${title.toLowerCase()}`}>
    <h4 className={s.title}>{title}</h4>
    {children}
  </li>
);

export default FilterGroup;
